module.exports = __webpack_public_path__ + "static/media/Tile Image - Cotton Trouser (1).af404698.jpg";